export const currentUserSelector = (state) => (state.users.data || []).find((user) => user.id === state.users.currentUserId);
